import axios from "axios";
import { Partner_Service_URL } from "../Url";

export const saveFiInfoActions = {
  SAVE_FI_INFO_EDITPARTNER_SUCCESS: "SAVE_FI_INFO_EDITPARTNER_SUCCESS",
  SAVE_FI_INFO_EDITPARTNER_ERROR: "SAVE_FI_INFO_EDITPARTNER_ERROR",
};

export function saveFiInfoDetails(props) {
  const { access_token, values, partnerFirmId } = props;

  return (dispatch) =>
    axios({
      method: "post",
      headers: {
        authorization: "Bearer " + access_token,
        "Access-Control-Allow-Origin": "*",
      },
      url: `${Partner_Service_URL}/savePartnerFiInfo?partnerFirmId=${partnerFirmId}`,
      data: values,
    })
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          dispatch(saveFiInfoApplicantDetailsSuccess(response));
          return response;
        } else {
          const error = new Error(response.statusText);
          dispatch(saveFiInfoApplicantDetailsError(error));
          throw error;
        }
      })
      .catch((err) => {
        if (err.response) {
          dispatch(saveFiInfoApplicantDetailsError(err));
          return err.response;
        }
      });
}

export function saveFiInfoApplicantDetailsError(error) {
  return {
    type: saveFiInfoActions.SAVE_FI_INFO_EDITPARTNER_SUCCESS,
    payload: error,
  };
}

export function saveFiInfoApplicantDetailsSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: saveFiInfoActions.SAVE_FI_INFO_EDITPARTNER_SUCCESS,
      payload: props,
    });
  };
}
